<template>
  <div class="about">
    <Game></Game>
  </div>
</template>

<script>
import Game from "@/components/Game";
export default {
  components: { Game }
};
</script>

<style scoped>
</style>
